import React from 'react';
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';

const ACDropdown = ({
  autoSelect = true,
  disableClearable = true,
  autoComplete = true,
  openOnFocus = true,
  autoHighlight = true,
  textFieldProps,
  label,
  ...props
}) => {
  const filterOptions = createFilterOptions({
    limit: 80,
  });

  return (
    <Autocomplete
      blurOnSelect="touch"
      autoSelect={autoSelect}
      disableClearable={disableClearable}
      autoComplete={autoComplete}
      openOnFocus={openOnFocus}
      autoHighlight={autoHighlight}
      renderInput={params => (
        <TextField
          {...params}
          {...textFieldProps}
          label={label}
          variant="outlined"
        />
      )}
      filterOptions={filterOptions}
      {...props}
    />
  );
};

export default ACDropdown;
